import React, { useMemo } from 'react'
import * as classes from './Directors.module.scss'
import cn from 'classnames'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'

function Directors({ data, lang }) {
    const nodes = data?.slides?.nodes || []

    const directors = nodes.filter((item) => item.category === 'director')
    const boardMembers = nodes.filter((item) => item.category === 'boardMember')

    const sectionTitle = useMemo(() => (data?.boardOfDirectors?.value ? deleteHtmlTag(data.boardOfDirectors.value, 'p') : ''), [data])

    if (!directors.length && !boardMembers.length) {
        return null
    }

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <Container>
                <SectionTitle className={classes.SectionTitle} title={sectionTitle || 'The Board of Directors'} lang={lang} />

                {directors.length ? (
                    <div className={classes.Row}>
                        {directors.map((item, index) => (
                            <div className={classes.DirectorCard} key={index}>
                                {item.photo?.url ? (
                                    <div className={classes.Photo} style={{ backgroundImage: `url(${item.photo.url})` }} />
                                ) : null}

                                <div className={classes.Info}>
                                    <span className={classes.Dash} />

                                    <div className={classes.NameRow}>{item.name ? <p className={classes.Name}>{item.name}</p> : null}</div>

                                    {item.positions ? <p className={classes.Position}>{item.positions}</p> : null}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}

                {boardMembers.length ? (
                    <div className={classes.RowSmall}>
                        {boardMembers.map((item, index) => (
                            <div className={classes.MemberCard} key={index}>
                                {item.photo?.url ? (
                                    <div className={classes.Photo} style={{ backgroundImage: `url(${item.photo.url})` }} />
                                ) : null}

                                <div className={classes.Info}>
                                    <div className={classes.NameRow}>{item.name ? <p className={classes.Name}>{item.name}</p> : null}</div>

                                    {item.positions ? <p className={classes.Position}>{item.positions}</p> : null}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </Container>
        </section>
    )
}

export default Directors
